import api from './api';
import { getSmtpConfig as getLocalSmtpConfig, saveSmtpConfig as saveLocalSmtpConfig, DEFAULT_SMTP_CONFIG } from '../utils/smtpConfig';

const SMTP_CONFIG_ENDPOINT = '/api/v1/config/smtp';
const EMAIL_TEMPLATES_ENDPOINT = '/api/v1/email-templates/';

class ConfigService {
  async getSmtpConfig() {
    try {
      const response = await api.get(SMTP_CONFIG_ENDPOINT);
      const remote = response?.data || {};
      const merged = {
        ...DEFAULT_SMTP_CONFIG,
        ...remote
      };

      saveLocalSmtpConfig(merged);
      return { success: true, data: merged, source: 'api' };
    } catch (_error) {
      return { success: true, data: getLocalSmtpConfig(), source: 'local' };
    }
  }

  async saveSmtpConfig(config) {
    const normalized = {
      ...DEFAULT_SMTP_CONFIG,
      ...config
    };

    saveLocalSmtpConfig(normalized);

    try {
      await api.put(SMTP_CONFIG_ENDPOINT, normalized);
      return { success: true, data: normalized, source: 'api' };
    } catch (_error) {
      return { success: true, data: normalized, source: 'local' };
    }
  }

  async getEmailTemplates() {
    try {
      const response = await api.get(EMAIL_TEMPLATES_ENDPOINT);
      const payload = response?.data;
      const templates = Array.isArray(payload) ? payload : (Array.isArray(payload?.items) ? payload.items : []);
      return { success: true, data: templates };
    } catch (error) {
      return { success: false, data: [], error: error?.response?.data?.detail || error.message };
    }
  }

  async saveEmailTemplate(templateId, templateData) {
    try {
      const payload = { ...templateData };
      if ('enabled' in payload) {
        payload.is_enabled = payload.enabled;
        delete payload.enabled;
      }
      const response = await api.put(`${EMAIL_TEMPLATES_ENDPOINT}${templateId}`, payload);
      return { success: true, data: response?.data || templateData };
    } catch (error) {
      return { success: false, error: error?.response?.data?.detail || error.message };
    }
  }

  async resetEmailTemplatesToDefaults() {
    try {
      const response = await api.post(`${EMAIL_TEMPLATES_ENDPOINT}reset-defaults`);
      return { success: true, data: response?.data || [] };
    } catch (error) {
      return { success: false, error: error?.response?.data?.detail || error.message };
    }
  }

  async setEmailTemplateEnabled(templateId, enabled) {
    const normalizedEnabled = Boolean(enabled);

    try {
      // Preferred: partial update endpoint for status only.
        const response = await api.put(`${EMAIL_TEMPLATES_ENDPOINT}${templateId}`, {
        is_enabled: normalizedEnabled
      });
      return { success: true, data: response?.data || { id: templateId, enabled: normalizedEnabled } };
    } catch (_error) {
      // Fallback: full update endpoint with only status fields.
      try {
          const response = await api.put(`${EMAIL_TEMPLATES_ENDPOINT}${templateId}`, {
          is_enabled: normalizedEnabled
        });
        return { success: true, data: response?.data || { id: templateId, enabled: normalizedEnabled } };
      } catch (error) {
        return { success: false, error: error?.response?.data?.detail || error.message };
      }
    }
  }

  async enableEmailTemplate(templateId) {
    return this.setEmailTemplateEnabled(templateId, true);
  }

  async disableEmailTemplate(templateId) {
    return this.setEmailTemplateEnabled(templateId, false);
  }
}

export default new ConfigService();